import { get } from 'lodash';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { ThemeStyle, TypographyWeight, TypographyStyle } from '@treelab/panda';

import { Typography } from '../../Typography';
import { IRootState } from '../../../modules/stores';
import { getTableColumnKey } from '../../../modules/space/helper';

import { Container, Crumb } from './styled';

type IConnectProps = ReturnType<typeof mapState>;
interface IProps {
  spaceId: string;
}

const BreadCrumbs: React.FC<IProps & IConnectProps> = ({ space, indexDepth, fieldById }) => {
  const [crumbs, setCrumbs] = useState<string[]>([]);

  useEffect(() => {
    const final: string[] = [];
    final.push(fieldById[space.fieldId!].name);
    indexDepth.forEach((_, idx: number) => {
      const key = getTableColumnKey(indexDepth.slice(0, idx + 1));
      const targetColId = get(space, `${key}.id`);

      if (targetColId) {
        final.push(fieldById[targetColId].name);
      }
    });

    setCrumbs(final);
  }, [indexDepth, fieldById, space]);

  if (crumbs.length < 2) return null;

  return (
    <Container>
      {crumbs.map((crumb, index) => (
        <Crumb key={index} isLast={index === crumbs.length - 1}>
          <Typography
            theme={ThemeStyle.white}
            type={TypographyStyle.P2}
            weight={TypographyWeight.Medium}
          >
            {crumb}
          </Typography>
        </Crumb>
      ))}
    </Container>
  );
};

const mapState = ({ space, core }: IRootState, { spaceId }: IProps) => ({
  space: space.byId[spaceId],
  indexDepth: space.indexDepth,
  fieldById: core.fieldById,
});

export default connect(mapState)(BreadCrumbs);
